import React from 'react';
import { ReactComponent as mailLink } from '../../assets/icons/mail_link.svg';
import { StyledAnchor } from './e-mail.styled';
import { SVG } from '../svg';

interface IProps {
  email: string;
}

export const EMail = React.memo(({ email }: IProps) => {
  return (
    <StyledAnchor
      href={`mailto:${email}`}
      target={'_blank'}
      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => e.stopPropagation()}
    >
      <SVG src={mailLink} props={{ color: '#2d67d8', cursor: 'pointer' }} />
    </StyledAnchor>
  );
});
